import { Rating } from "react-simple-star-rating";
import { Card, CardBody, CardFooter, Col, Row } from "reactstrap";
import { H4, Image, LI, P, UL } from "../../../AbstractElements";
import { FeaturedTutorialsTitle } from "../../../Constants/Constants";
import { FeaturedTutorialsData } from "../../../Data/Miscellaneous/FAQ";
import { dynamicImage } from "../../../Utils";

const FeaturedTutorials = () => {
  return (
    <Col lg="12">
      <div className="header-faq">
        <H4 className="mb-0 f-w-600">{FeaturedTutorialsTitle}</H4>
      </div>
      <Row>
        {FeaturedTutorialsData.map((data) => (
          <Col xxl="3" md="6" className="box-col-6" key={data.id}>
            <Card className="features-faq product-box">
              <div className="faq-image product-img">
                <Image className="img-fluid" src={dynamicImage(`faq/${data.image}`)} alt="featured image" />
                <div className="product-hover">
                  <UL className="simple-list flex-row">
                    <LI><i className="icon-link"></i></LI>
                    <LI><i className="icon-import"></i></LI>
                  </UL>
                </div>
              </div>
              <CardBody>
                <H4>{data.title}</H4>
                <P>{data.description}</P>
              </CardBody>
              <CardFooter>
                <span>{data.date}</span>
                <span className="pull-right"><Rating fillColor="#2A5699" initialValue={Math.random() * 5} size={16} /></span>
              </CardFooter>
            </Card>
          </Col>
        ))}
      </Row>
    </Col>
  );
};
export default FeaturedTutorials;
